const persianNumbersList = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbersList = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];
const persianNumbers = "\u06F0-\u06F9"; // ۰ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹
const arabicNumbers = "\u0660-\u0669"; // ۰ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹
const operatorsMap = {
  shatelMobile: "شاتل موبایل",
  MCI: "همراه اول",
  Irancell: "ایرانسل",
  Taliya: "تالیا",
  RightTel: "رایتل",
};

const lineType = {
  permanent: "دائمی",
  credit: "اعتباری",
};

const MCI = {
  910: {
    base: "کشوری",
    province: [],
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  914: {
    province: ["آذربایجان شرقی", "اردبیل", "اصفهان"],
    base: "آذربایجان غربی",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  911: {
    province: ["گلستان", "گیلان"],
    base: "مازندران",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  912: {
    province: [
      "البرز",
      "زنجان",
      "سمنان",
      "قزوین",
      "قم",
      "برخی از شهرستان های استان مرکزی",
    ],
    base: "تهران",
    type: [lineType.permanent],
    operator: operatorsMap.MCI,
  },
  913: {
    province: ["یزد", "چهارمحال و بختیاری", "کرمان"],
    base: "اصفهان",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  915: {
    province: ["خراسان شمالی", "خراسان جنوبی", "سیستان و بلوچستان"],
    base: "خراسان رضوی",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  916: {
    province: ["لرستان", "فارس", "اصفهان"],
    base: "خوزستان",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  917: {
    province: ["بوشهر", "کهگیلویه و بویر احمد", "هرمزگان"],
    base: "فارس",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  918: {
    province: ["کردستان", "ایلام", "همدان"],
    base: "کرمانشاه",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  919: {
    province: ["البرز", "سمنان", "قم", "قزوین", "زنجان"],
    base: "تهران",
    type: [lineType.credit],
    operator: operatorsMap.MCI,
  },
  990: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.MCI,
  },
  991: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  992: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.MCI,
  },
  993: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.MCI,
  },
  994: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.MCI,
  },
  995: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
  996: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.MCI,
  },
};

const Taliya = {
  932: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.Taliya,
  },
};

const RightTel = {
  920: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent],
    operator: operatorsMap.RightTel,
  },
  921: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.RightTel,
  },
  922: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.RightTel,
  },
  923: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.RightTel,
  },
};

const Irancell = {
  930: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  933: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  935: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  936: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  937: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  938: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  939: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  901: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  902: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  903: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  905: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  900: {
    province: [],
    base: "کشوری",
    type: [lineType.permanent, lineType.credit],
    operator: operatorsMap.Irancell,
  },
  904: {
    province: [],
    base: "کشوری",
    model: "سیم‌کارت کودک",
    type: [lineType.credit],
    operator: operatorsMap.Irancell,
  },
  941: {
    province: [],
    base: "کشوری",
    model: "TD-LTE",
    type: [lineType.credit],
    operator: operatorsMap.Irancell,
  },
};

const ShatelMobile = {
  998: {
    province: [],
    base: "کشوری",
    type: [lineType.credit],
    operator: operatorsMap.shatelMobile,
  },
};

const prefixes = [
  ...Object.keys(MCI),
  ...Object.keys(Taliya),
  ...Object.keys(RightTel),
  ...Object.keys(Irancell),
  ...Object.keys(ShatelMobile),
];

const operators = {
  ...MCI,
  ...Taliya,
  ...Irancell,
  ...ShatelMobile,
  ...RightTel,
};

const phoneNumberInfo = (mobile) => {
  const getPhonePrefix = (mobile) => {
    const phoneCountryPrefix = `${mobile}`.match(
      `^([\+98|98|0098|0]{0,})([9]{1})([0-9]{9})$`
    );

    const prefix =
      phoneCountryPrefix &&
      mobile.replace(phoneCountryPrefix[1], "").slice(0, 3);
    return prefix || "";
  };

  if (isPhoneNumber(mobile) && prefixes.includes(getPhonePrefix(mobile))) {
    const prefix = getPhonePrefix(mobile);

    return operators[prefix];
  }

  return null;
};

const isPhoneNumber = (str) => {
  //   const reg = new RegExp(
  //     `^[09||\u0660\u0669||\u06F0\u06F9][0-9${persianNumbers}${arabicNumbers}]{9}$`
  //   );
  //   for (let i = 0; i < 10; i += 1) {
  //     str = str
  //       .replaceAll(persianNumbersList[i], i)
  //       .replace(arabicNumbersList[i], i);
  //   }
  const reg = new RegExp(`^([\+98|98|0098|0]{0,})([9]{1})([0-9]{9})$`);

  return reg.test(str);
};

module.exports = {
  isPhoneNumber,
  phoneNumberInfo,
};
